<template>
  <b-modal
    :id="id"
    :ref="`completeModal${announcement.id}`"
    :ok-only="true"
    @hide="handleOkButtonClick">
    <div
      v-dompurify-html="announcement.content" />
  </b-modal>
</template>

<script>
import ModalMixin from '../../mixins/ModalMixin';

export default {
  mixins: [ ModalMixin ],
  props: {
    announcement: {
      type: Object,
      default: null
    }
  },
  methods: {
    handleOkButtonClick() {
      this.$store.dispatch('announcement/addAnnouncementSeen', this.announcement.id);
    }
  }
};
</script>

<style scoped lang="scss">

</style>